export const REQUEST_ORGS_REASSIGN = 'REQUEST_ORGS_REASSIGN';
export const ORGS_REASSIGN_REQUEST_COMPLETED =
  'ORGS_REASSIGN_REQUEST_COMPLETED';
export const ORGS_REASSIGN_REQUEST_FAILED = 'ORGS_REASSIGN_REQUEST_FAILED';
